import { render, staticRenderFns } from "./H5PPlayer.vue?vue&type=template&id=3b020c24&scoped=true&"
import script from "./H5PPlayer.vue?vue&type=script&lang=js&"
export * from "./H5PPlayer.vue?vue&type=script&lang=js&"
import style0 from "./H5PPlayer.vue?vue&type=style&index=0&id=3b020c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b020c24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
